/**
 * Tab List Component Exports
 *
 * @since 1.0.0
 */

export { TabList } from './component';
export type { Tab } from './types';
